import { ErrorMessage, Field, Form, Formik } from 'formik';


import React from 'react';
import { Card, Tabs, Tab, Button, DropdownButton, ProgressBar } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { myFirestore } from '../../../services/firebase'
import * as Yup from 'yup';

import './intakeform3.css';



class IntakeForm3 extends React.Component {
  constructor(props) {
    super(props)

    this.uid = this.props.auth.uid;
    this.now = 0;
  }
  state = {
    key: 'home'
  }
  setKey = (keey) => {
    if (keey === 'home') {
      this.now = 0;
    }
    if (keey === 'family') {
      this.now = 50;
    }
    else if (keey === 'other') {
      this.now = 100;
    }
    this.setState({ key: keey })
  }


  saveform = (fields) => {
    console.log(fields, this.uid)

    myFirestore
      .collection('intakeform3')
      .doc(this.uid)
      .set({
        id: this.uid,
        currentMedicalProblems: fields.currentMedicalProblems,
        pastMedicalProblems: fields.pastMedicalProblems,

        personalMedicalHistory: fields.personalMedicalHistory,
        otherPersonalMedicalHistory: fields.otherPersonalMedicalHistory,

        currentPrescriptionMedications: fields.currentPrescriptionMedications,

        currentOTCMedications: fields.currentOTCMedications,
        complicationsDuringThePregnancy: fields.complicationsDuringThePregnancy,

        familyMedicalHistory: fields.familyMedicalHistory,
        otherFamilyMedicalHistory: fields.otherFamilyMedicalHistory,


        dateOfLastMenstrual: fields.dateOfLastMenstrual,
        currentlyPregnant: fields.currentlyPregnant,

        planningToGetPregnant: fields.planningToGetPregnant,
        birthControlMethod: fields.birthControlMethod,

      },
        { merge: true })
      .then(() => {
        this.props.showToast(1, 'Form submitted sucessfully')
        this.props.history.push('/')


      })
      .catch(err => {
        this.props.showToast(0, err.toString())
      })

  }

  handleSubmit = (values, {
    setSubmitting
  }) => {

    alert(JSON.stringify(values, null, 2));

    setSubmitting(false);

    return;
  }


  render() {
    const { auth } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <>
        <Formik
          initialValues={{

            currentMedicalProblems: '',
            pastMedicalProblems: '',

            personalMedicalHistory: [],
            otherPersonalMedicalHistory: '',
            otherPMH: false,
            currentPrescriptionMedications: '',

            currentOTCMedications: '',
            complicationsDuringThePregnancy: '',

            familyMedicalHistory: [],
            otherFamilyMedicalHistory: '',
            otherFMH: false,

            dateOfLastMenstrual: '',
            currentlyPregnant: false,

            planningToGetPregnant: false,
            birthControlMethod: '',

            youMenstruate:false,

            haveAnyFamilyProblems:false,

          }}
          validationSchema={Yup.object().shape({



          })}
          onSubmit={fields => {


            this.saveform(fields);

          }}

        >
          {({ errors, touched, values }) => (



            <Container className="intake-container" fluid>



              <Card className="intake-card">


                <Form>
                  <ProgressBar now={this.now} variant="success" />
                  <Tabs

                    justify
                    activeKey={this.state.key}
                    onSelect={(k) => this.setKey(k)}


                  >
                    <Tab eventKey="home" title="Personal Medical History" >


                      <div className="form-group ">
                        <label htmlFor="currentMedicalProblems">Current medical problems :  </label>
                        <Field name="currentMedicalProblems" type="text" className={'form-control' + (errors.currentMedicalProblems && touched.currentMedicalProblems ? ' is-invalid' : '')} />
                        <ErrorMessage name="currentMedicalProblems" component="div" className="invalid-feedback" />
                      </div>

                      <div className="form-group ">
                        <label htmlFor="text">Past medical problems :</label>


                        <DropdownButton variant='light' id="dropdown-basic-button" title="Choose Medical Problems">
                          <div className='form-group row'>
                            <div className="form-group form-check  ">

                              <Field type="checkbox" name="personalMedicalHistory" value='Thyroid Disease' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">Thyroid Disease</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='Anaemia' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">Anaemia</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='Chronic Fatigue' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">Chronic Fatigue</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='Diabetes' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">Diabetes</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='Cancer' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">Cancer</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='PCOS' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">PCOS</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='Fibromyalgia' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">Fibromyalgia</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='Epilepsy or seizures' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label"> Epilepsy or seizures </label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='Chronic Pain' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">Chronic Pain</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="personalMedicalHistory" value='Head trauma' className={'form-check-input '} />
                              <label htmlFor="personalMedicalHistory" className="form-check-label">Head trauma</label>
                              <ErrorMessage name="personalMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="otherPMH" className={'form-check-input '} />
                              <label htmlFor="otherPMH" className="form-check-label">Other</label>
                              <ErrorMessage name="otherPMH" component="div" className="invalid-feedback" />

                            </div>
                            {values.otherPMH &&
                              <div className="form-group">

                                <Field name="otherPersonalMedicalHistory" type="text" className={'form-control' + (errors.otherPersonalMedicalHistory && touched.otherPersonalMedicalHistory ? ' is-invalid' : '')} />
                                <ErrorMessage name="otherPersonalMedicalHistory" component="div" className="invalid-feedback" />
                              </div>
                            }
                          </div>
                        </DropdownButton>



                      </div>
                      {/* <div className="form-group form-check  ">
    <Field type="checkbox" name="other" className={'form-check-input '} />
    <label htmlFor="other" className="form-check-label">Is there any additional personal medical history?</label>
    <ErrorMessage name="other" component="div" className="invalid-feedback" />

  </div>
  {values.other &&
    <div className="form-group">
      If yes, please explain:
      <Field name="othersubstance" type="text" className={'form-control' + (errors.othersubstance && touched.othersubstance ? ' is-invalid' : '')} />
      <ErrorMessage name="othersubstance" component="div" className="invalid-feedback" />
    </div>
  } */}
                      <div className="form-group ">
                        <label htmlFor="currentPrescriptionMedications">Any current or past psychiatric diagnosis? </label>
                        <Field name="currentPrescriptionMedications" type="text" className={'form-control' + (errors.currentPrescriptionMedications && touched.currentPrescriptionMedications ? ' is-invalid' : '')} />
                        <ErrorMessage name="currentPrescriptionMedications" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group ">
                        <label htmlFor="currentOTCMedications">Are you currently taking any medications?  </label>
                        <Field name="currentOTCMedications" type="text" className={'form-control' + (errors.currentOTCMedications && touched.currentOTCMedications ? ' is-invalid' : '')} />
                        <ErrorMessage name="currentOTCMedications" component="div" className="invalid-feedback" />
                      </div>



                      <div className="row justify-content-center">
                        <Button className="btn button mr-2" onClick={() => this.setKey("family")}>Save progress & Skip </Button>
                      </div>


                    </Tab>
                    <Tab eventKey="family" title="Family Medical History">







                    <div className="form-group form-check  ">
                              <Field type="checkbox" name="haveAnyFamilyProblems" className={'form-check-input '} />
                              <label htmlFor="haveAnyFamilyProblems" className="form-check-label">Does your family have any significant medical history?</label>
                              <ErrorMessage name="haveAnyFamilyProblems" component="div" className="invalid-feedback" />

                            </div>
                      {values.haveAnyFamilyProblems?
                      <>
                      <div className="form-group ">
                        <label htmlFor="text">Family Medical History: </label>
                        <DropdownButton variant='light' id="dropdown-basic-button" title="Choose Medical Problems">
                          <div className='form-group row'>

                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Thyroid Disease' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">Thyroid Disease</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Anaemia' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">Anaemia</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Chronic Fatigue' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">Chronic Fatigue</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Diabetes' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">Diabetes</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Cancer' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">Cancer</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='PCOS' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">PCOS</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Fibromyalgia' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">Fibromyalgia</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Epilepsy or seizures' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label"> Epilepsy or seizures </label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Chronic Pain' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">Chronic Pain</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="familyMedicalHistory" value='Head trauma' className={'form-check-input '} />
                              <label htmlFor="familyMedicalHistory" className="form-check-label">Head trauma</label>
                              <ErrorMessage name="familyMedicalHistory" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group form-check  ">
                              <Field type="checkbox" name="otherFMH" className={'form-check-input '} />
                              <label htmlFor="otherFMH" className="form-check-label">Other</label>
                              <ErrorMessage name="otherFMH" component="div" className="invalid-feedback" />

                            </div>
                            {values.otherFMH &&
                              <div className="form-group">

                                <Field name="otherFamilyMedicalHistory" type="text" className={'form-control' + (errors.otherFamilyMedicalHistory && touched.otherFamilyMedicalHistory ? ' is-invalid' : '')} />
                                <ErrorMessage name="otherFamilyMedicalHistory" component="div" className="invalid-feedback" />
                              </div>
                            }


                          </div>
                        </DropdownButton>

                      </div>
                      {/* /* <div className="form-group form-check  ">
<Field type="checkbox" name="other" className={'form-check-input '} />
<label htmlFor="other" className="form-check-label">Is there any additional family medical history? </label>
<ErrorMessage name="other" component="div" className="invalid-feedback" />

</div>
{values.other &&
<div className="form-group">
If yes, please explain:
<Field name="othersubstance" type="text" className={'form-control' + (errors.othersubstance && touched.othersubstance ? ' is-invalid' : '')} />
<ErrorMessage name="othersubstance" component="div" className="invalid-feedback" />
</div>
} */ }
                      <div className="form-group ">
                        <label htmlFor="text">Any family history of psychiatric illness : </label>
                        <div className="form-group ">
                        <label htmlFor="relation">(please specify relation with the person)  </label>
                        <Field name="relation" type="text" className={'form-control'} />
                        <ErrorMessage name="relation" component="div" className="invalid-feedback" />
                      </div>
                      <div className='row form-group'>

                        <div className="form-group form-check  ">
                          <Field type="checkbox" name="psychiatricillness" value='Depression' className={'form-check-input '} />
                          <label htmlFor="psychiatricillness" className="form-check-label">Depression</label>
                          <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group form-check  ">
                          <Field type="checkbox" name="psychiatricillness" value='Anxiety' className={'form-check-input '} />
                          <label htmlFor="psychiatricillness" className="form-check-label">Anxiety</label>
                          <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group form-check  ">
                          <Field type="checkbox" name="psychiatricillness" value='OCD' className={'form-check-input '} />
                          <label htmlFor="psychiatricillness" className="form-check-label">OCD</label>
                          <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group form-check  ">
                          <Field type="checkbox" name="psychiatricillness" value='Schizophrenia' className={'form-check-input '} />
                          <label htmlFor="psychiatricillness" className="form-check-label">Schizophrenia</label>
                          <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group form-check  ">
                          <Field type="checkbox" name="psychiatricillness" value='Substance Abuse' className={'form-check-input '} />
                          <label htmlFor="psychiatricillness" className="form-check-label">Substance Abuse</label>
                          <ErrorMessage name="psychiatricillness" component="div" className="invalid-feedback" />
                        </div>


                      </div>

                      </div>
                      <div className="form-group ">
                        <label htmlFor="text">Any incidents of suicide in your family? : </label>
                        
                        <label htmlFor="suicide">(please specify relation with the person)  </label>
                        <Field name="suicide" type="text" className={'form-control' + (errors.suicide && touched.suicide ? ' is-invalid' : '')} />
                        <ErrorMessage name="suicide" component="div" className="invalid-feedback" />
                     
                      </div>
                      </>
                      :null}
                      <div className="row justify-content-center" style={{marginTop:'4rem'}}>
                        <Button className="btn button " onClick={() => this.setKey("other")}>Save progress Or Skip </Button>
                      </div>
                     

                    </Tab>
                    <Tab eventKey="other" title="Other" >
                      <div className="form-group">
                        <label htmlFor="complicationsDuringThePregnancy">Did your mother experience any complications during pregnancy or while giving birth to you?   </label>
                        <Field name="complicationsDuringThePregnancy" type="text" className={'form-control' + (errors.complicationsDuringThePregnancy && touched.complicationsDuringThePregnancy ? ' is-invalid' : '')} />
                        <ErrorMessage name="complicationsDuringThePregnancy" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="youMenstruate" className={'form-check-input '} />
                        <label htmlFor="youMenstruate" className="form-check-label">Mentrual History?, if applicable</label>
                        <ErrorMessage name="youMenstruate" component="div" className="invalid-feedback" />

                      </div>
                      {values.youMenstruate?
                      <>
                      <div className="form-group">
                        <label htmlFor="dateOfLastMenstrual">Date of last menstrual period : </label>
                        <Field name="dateOfLastMenstrual" type="text" className={'form-control' + (errors.dateOfLastMenstrual && touched.dateOfLastMenstrual ? ' is-invalid' : '')} />
                        <ErrorMessage name="dateOfLastMenstrual" component="div" className="invalid-feedback" />
                      </div>
                      
                      <div className="form-group">
                        <label htmlFor="dateOfLastMenstrual">Any complications experienced : </label>
                        <Field name="dateOfLastMenstrual" type="text" className={'form-control' + (errors.dateOfLastMenstrual && touched.dateOfLastMenstrual ? ' is-invalid' : '')} />
                        <ErrorMessage name="dateOfLastMenstrual" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="currentlyPregnant" className={'form-check-input '} />
                        <label htmlFor="currentlyPregnant" className="form-check-label">Are you currently pregnant or do you think you might be pregnant? </label>
                        <ErrorMessage name="currentlyPregnant" component="div" className="invalid-feedback" />

                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="planningToGetPregnant" className={'form-check-input '} />
                        <label htmlFor="planningToGetPregnant" className="form-check-label">Are you planning to get pregnant in the near future? </label>
                        <ErrorMessage name="planningToGetPregnant" component="div" className="invalid-feedback" />

                      </div>
                      <div className="form-group">
                        <label htmlFor="birthControlMethod">Birth control method : </label>
                        <Field name="birthControlMethod" type="text" className={'form-control' + (errors.birthControlMethod && touched.birthControlMethod ? ' is-invalid' : '')} />
                        <ErrorMessage name="birthControlMethod" component="div" className="invalid-feedback" />
                      </div>
                      </>
                      :null
                      }
                      <div className="row justify-content-center">
                      <button type="submit" className="btn button mr-2 ">Submit </button>
                      </div>
                    </Tab>
                  </Tabs>


                  {/* <div className="row justify-content-center">

                    <button type="submit" className="btn button mr-2 ">Submit </button>
                    <button type="reset" className="btn" style={{ width: '15rem', borderColor: '#40817a', borderRadius: '1rem', margin: '0.2rem' }}>Reset</button>
                  </div> */}
                </Form>

              </Card>

            </Container>





          )}

        </Formik>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  }
}



export default connect(mapStateToProps)(IntakeForm3)
